import React, { useState, useRef, useEffect } from 'react';
import { useI18n, LANGUAGES } from '../hooks/useI18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const AuthLangSwitcher: React.FC = () => {
  const { language, setLanguage } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="auth-lang-switcher" ref={ref}>
      <button className="auth-lang-btn" onClick={() => setOpen(!open)} type="button">
        <span className="lang-flag">{current.flag}</span>
        <span>{current.code.toUpperCase()}</span>
        <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: 10, opacity: 0.6 }} />
      </button>
      {open && (
        <div className="auth-lang-dropdown">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              className={`auth-lang-option${lang.code === language ? ' active' : ''}`}
              onClick={() => { setLanguage(lang.code); setOpen(false); }}
              type="button"
            >
              <span className="lang-flag">{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AuthLangSwitcher;
